module.exports = __webpack_public_path__ + "media/csgo_ui_crate_open.f2cff0db.wav";